import React, { useEffect, useState } from 'react';
import { utils, writeFile } from 'xlsx';
import {
	Alert,
	Box,
	Button,
	Card,
	CardContent,
	Container,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Select,
	Snackbar,
	TextField,
	Tooltip,
	Typography,
	useMediaQuery,
} from '@mui/material';
import BrandedLoader from '../../components/BrandedLoader/BrandedLoader';
import SearchIcon from '@mui/icons-material/Search';
import icon3 from '../../../assets/logos/icon3.png';
import MenuIcon from '@mui/icons-material/Menu';

import Icon from '../../../assets/logos/Icon.png';

import { DataGrid } from '@mui/x-data-grid';

import Group5 from '../../../assets/logos/Group5.png';

import Group6 from '../../../assets/logos/Group6.png';

import eye from '../../../assets/logos/eye.png';

import TablePagination from '@mui/material/TablePagination';

import icon5 from '../../../assets/logos/icon5.png';

import Menu from '@mui/material/Menu';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { useTheme } from '@emotion/react';
import {
	getBatches,
	getBatchesDetails,
	getBatchesWithbatch_id,
	getPracticeStaff,
	getUserPractices,
	getVisit,
	updateBatch,
} from '../../services/api/apiManager';
import dayjs from 'dayjs';
import { ArrowDropDown, Cancel } from '@mui/icons-material';

const batchModalPaperSx = {
	borderRadius: '10px',
	overflow: 'hidden',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	border: '1px solid #dce8f5',
};

const batchModalLabelSx = {
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 600,
	color: '#0b2450',
	mb: 0.7,
};

const batchModalFieldSx = {
	'& .MuiOutlinedInput-root': {
		minHeight: '42px',
		borderRadius: '6px',
		fontFamily: 'Poppins',
		fontSize: '13px',
		'& fieldset': { borderColor: '#d7e3f4' },
		'&:hover fieldset': { borderColor: '#b8c9e0' },
		'&.Mui-focused fieldset': {
			borderColor: '#2f6edb',
			borderWidth: '1px',
		},
	},
	'& .MuiInputBase-input': {
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#0b2450',
	},
};

const batchModalOutlineButtonSx = {
	height: '40px',
	minWidth: '112px',
	borderRadius: '6px',
	border: '1px solid #cfd9e8',
	backgroundColor: '#fff',
	color: '#344054',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
	'&:hover': { backgroundColor: '#f8fafc', borderColor: '#b9c6d8' },
};

const batchModalPrimaryButtonSx = {
	height: '40px',
	minWidth: '122px',
	borderRadius: '6px',
	backgroundColor: '#2f6edb',
	color: '#fff',
	fontFamily: 'Poppins',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
	boxShadow: '0 4px 12px rgba(47, 110, 219, 0.24)',
	'&:hover': { backgroundColor: '#245fc5' },
	'&.Mui-disabled': {
		backgroundColor: '#d7dce5',
		color: '#98a2b3',
		boxShadow: 'none',
	},
};

function Batches() {
	const practiceId_fromLocal = localStorage.getItem('practice_id');
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [postSucessfully, setPostSucessfully] = useState(true);
	const [batchDeleted, setBatchDeleted] = useState(false);
	const [reRenderAgain, setRerenderAgain] = useState(0);
	const [loader, setLoader] = useState(false);
	const [batchesLoader, setBatchesLoader] = useState(false);
	const [isClicked, setClicked] = useState(0);
	const [firstBatch, setfirstBatch] = useState({});
	const [open, setOpen] = useState(false);
	const [page, setPage] = React.useState(2);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [provider, setProvider] = useState('');
	const [filterData, setFilterData] = useState([]);
	const [searchBy, setSearchBy] = useState('');
	const [batchesStatus, setBatchesStatus] = useState('');
	const [filterBatchWithStatus, setFilterBatchWithStatus] = useState([]);
	const [batchesDetailsData, setBatchesDetailsData] = useState([]);
	const [allBatchData, setAllBatchData] = useState([]);
	const [currentlySelecteBatch, setCurrentlySelecteBatch] = useState({
		id: 0,
		BatchName: '',
		charges: 0,
		CreatedDate: '',
	});
	const [selectedBatchGrid, setSelectedBatchGrid] = useState([]);
	// update batch modal inputfields and button
	const [updateBatchName, setUpdateBatchName] = useState('');
	const [updateAssignTo, setUpdateAssignTo] = useState('');
	// const [updateBatchDescr, setUpdateBatchDescr] = useState('');

	const [practiceStaff, setPracticeStaff] = useState([]);
	const [visitData, setVisitData] = useState([]);
	// 	// pagination
	// Last 30 day visit
	const [paginationPage, setPaginationPage] = useState(1); // Set the initial page number
	const [pageSize, setPageSize] = useState(10); // Set the initial page size
	const [pagination, setPagination] = useState(null);
	const handleSearchByFilter = (event) => {
		setSearchBy(event.target.value);
		if (event.target.value === '') {
			setFilterData(selectedBatchGrid);
		} else {
			const searching = selectedBatchGrid?.filter((items) => {
				return (
					(
						items?.patient?.Fname.toLowerCase() +
						' ' +
						items?.patient?.Lname.toLowerCase()
					).includes(event.target.value?.toLowerCase().trim()) ||
					(
						items?.patient?.Lname.toLowerCase() +
						' ' +
						items?.patient?.Fname.toLowerCase()
					).includes(event.target.value?.toLowerCase().trim())
				);
			});
			setFilterData(searching);
		}
	};

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleClick = (items) => {
		setClicked(items.id);
		setCurrentlySelecteBatch({
			id: items?.id,
			BatchName: items?.BatchName,
			charges: items?.num_visits,
			CreatedDate:
				items?.AssignedTo === null
					? ''
					: dayjs(items?.CreatedDate).format('MM-DD-YYYY'),
		});
		// we filter visitData with match of batch id from here
		setSelectedBatchGrid(visitData?.filter((i) => i.batch_id == items.id));
		setFilterData(visitData?.filter((i) => i.batch_id == items.id));
	};

	const textStyles = (id) => ({
		padding: '10px',
		margin: '5px 8px',
		cursor: 'pointer',
		borderRadius: '10px',
		border: isClicked === id ? '1px solid #1D60C5' : '1px solid lightgray',
		// boxShadow: isClicked === id ? '0 0 1rem 1rem #F2F4F6' : 'none',
		// boxShadow: isClicked === id ? '0px 1px 15px 0px #075AD74F' : 'none',
		// backgroundColor: isClicked === id ? '#F2F4F6' : '#FBFDFF',
	});

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	const batchesStatusHandler = (event) => {
		setBatchesStatus(event.target.value);
		const filteration = batchesDetailsData.filter((items) => {
			return items.BatchStatus == event.target.value;
		});
		if (event.target.value === 'E' || event.target.value === 'P') {
			setfirstBatch(filteration?.length > 0 ? filteration[0] : '');
		} else {
			setfirstBatch(allBatchData[0]);
		}

		setFilterBatchWithStatus(filteration);
	};

	const providerHandler = (event) => {
		setProvider(event.target.value);
	};
	const batchCardSx = (id) => ({
		display: 'block',
		position: 'relative',
		p: '14px',
		pl: '74px',
		my: 1.2,
		cursor: 'pointer',
		borderRadius: '7px',
		border: isClicked === id ? '1px solid #1f66ff' : '1px solid #e4ebf6',
		backgroundColor: isClicked === id ? '#eef7ff' : '#fff',
		boxShadow: 'none',
		transition: 'border-color 120ms ease, background-color 120ms ease',
		'&:hover': {
			backgroundColor: '#f6faff',
			borderColor: '#bfd3f2',
		},
	});
	const statusPill = (status) => {
		const config =
			status === 'A'
				? { label: 'Approved', color: '#09913d', bg: '#eaf8ef' }
				: status === 'B'
					? { label: 'Billed', color: '#ff6b1a', bg: '#fff1e8' }
					: status === 'D'
						? { label: 'Draft', color: '#ff9800', bg: '#fff7e7' }
						: { label: 'Others', color: '#e53935', bg: '#ffecec' };

		return (
			<Box
				sx={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: 0.6,
					px: 1.1,
					height: 24,
					borderRadius: '999px',
					bgcolor: config.bg,
					color: config.color,
					fontSize: '11px',
					fontWeight: 700,
					fontFamily: 'Poppins',
				}}
			>
				<Box
					component="span"
					sx={{
						width: 6,
						height: 6,
						borderRadius: '50%',
						bgcolor: config.color,
					}}
				/>
				{config.label}
			</Box>
		);
	};
	const gridSx = {
		border: 0,
		fontFamily: 'Poppins',
		color: '#172d58',
		'& .MuiDataGrid-columnHeader': {
			backgroundColor: '#f7f9fc',
			color: '#172d58',
			fontFamily: 'Poppins',
			fontWeight: 700,
			fontSize: '12px',
			overflow: 'hidden',
		},
		'& .MuiDataGrid-columnHeaders': {
			borderBottom: '1px solid #e6edf7',
		},
		'& .MuiDataGrid-cell': {
			borderBottom: '1px solid #edf2f8',
			fontFamily: 'Poppins',
			fontSize: '12px',
			fontWeight: 500,
			color: '#172d58',
			outline: 'none',
		},
		'& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': {
			outline: 'none',
		},
		'& .MuiDataGrid-row:hover': {
			backgroundColor: '#f8fbff',
		},
		'& .MuiDataGrid-footerContainer': {
			justifyContent: 'flex-end',
			backgroundColor: '#fff',
			borderTop: '1px solid #e6edf7',
			minHeight: '44px',
			height: '44px',
			px: 1.5,
			pr: 1.5,
		},
		'& .MuiTablePagination-toolbar': {
			minHeight: '44px',
			height: '44px',
			gap: '8px',
			px: 0,
			pr: 0,
		},
		'& .MuiTablePagination-root': {
			overflow: 'hidden',
		},
		'& .MuiInputBase-root': {
			border: '1px solid #dfe7f3',
			width: '58px',
			height: '34px',
			borderRadius: '6px',
			backgroundColor: 'white',
			fontFamily: 'Poppins',
			fontSize: '12px',
		},
		'& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
			fontFamily: 'Poppins',
			fontSize: '12px',
			color: '#172d58',
			fontWeight: 600,
		},
		'& .MuiTablePagination-actions': {
			display: 'flex',
			gap: '8px',
			ml: 1,
			mr: 0,
		},
		'& .MuiTablePagination-actions .MuiIconButton-root': {
			width: 32,
			height: 32,
			border: '1px solid #e4ebf6',
			borderRadius: '50%',
			backgroundColor: '#fff',
			color: '#1f66ff',
			p: 0,
		},
		'& .MuiTablePagination-actions .MuiIconButton-root:hover': {
			backgroundColor: '#f4f8ff',
		},
		'& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled': {
			color: '#b9c7dc',
			borderColor: '#e4ebf6',
			backgroundColor: '#fff',
		},
		'& .MuiDataGrid-virtualScroller': {
			scrollbarWidth: 'thin',
		},
		'& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
			width: '6px',
			height: '6px',
		},
		'& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
			backgroundColor: '#c7d4e8',
			borderRadius: '999px',
		},
	};
	const columns = [
		// {
		// 	field: 'icon',
		// 	headerName: '',
		// 	width: 5,
		// 	renderCell: () => {
		// 		return (
		// 			<div>
		// 				<img src={Group6} width="8.8px" style={{ cursor: 'pointer' }} />
		// 				,
		// 				<img src={Group5} width="17px" style={{ cursor: 'pointer' }} />
		// 			</div>
		// 		);
		// 	},
		// },
		{
			field: 'patientName',
			headerName: 'Patient Name',
			minWidth: 160,
			flex: 1,
		},
		{
			field: 'ProviderName',
			headerName: 'Provider Name',
			minWidth: 150,
			flex: 1,
		},
		{
			field: 'visitDate',
			headerName: 'Visit Date',
			minWidth: 130,
			flex: 0.8,
		},
		{
			field: 'charges',
			headerName: 'Charges',
			minWidth: 280,
			flex: 1.4,
			renderCell: (params) => (
				<Box sx={{ minWidth: 0, width: '100%' }}>
					<Typography
						noWrap
						sx={{
							fontFamily: 'Poppins',
							fontSize: '12px',
							color: '#172d58',
							lineHeight: 1.4,
						}}
					>
						<span
							style={{
								color: '#005bff',
								fontWeight: 700,
							}}
						>
							{params?.row?.charges?.length > 0
								? params?.row?.charges?.map((data) =>
										data?.CPTCode === null ? '' : data?.CPTCode + ','
									)
								: ''}
						</span>
						{/* {params.row.charges.length > 0
							? params.row.charges.map((data) => data.Description + '')
							: ' '}{' '} */}
						<br />
						<Tooltip
							sx={{
								'& .MuiTooltip-tooltip': {
									letterSpacing: 2,
								},
							}}
							title={
								<>
									{`${params.row.Dxcode1 !== null ? params.row.Dxcode1 : ''} ${params.row.Dx1Description}`}{' '}
									{params?.row?.Dx1Description && <br />}
									{` ${params.row.Dxcode2 !== null ? params.row.Dxcode2 : ''} ${params.row.Dx2Description}`}
									{params?.row?.Dx2Description && <br />}
									{` ${params.row.Dxcode3 !== null ? params.row.Dxcode3 : ''} ${params.row.Dx3Description}`}
									{params?.row?.Dx3Description && <br />}
									{` ${params.row.Dxcode4 !== null ? params.row.Dxcode4 : ''} ${params.row.Dx4Description}`}
									{params?.row?.Dx4Description && <br />}
									{` ${params.row.Dxcode5 !== null ? params.row.Dxcode5 : ''} ${params.row.Dx5Description}`}
									{params?.row?.Dx5Description && <br />}
									{` ${params.row.Dxcode6 !== null ? params.row.Dxcode6 : ''} ${params.row.Dx6Description}`}
									{params?.row?.Dx6Description && <br />}
									{` ${params.row.Dxcode7 !== null ? params.row.Dxcode7 : ''} ${params.row.Dx7Description}`}
									{params?.row?.Dx7Description && <br />}
									{` ${params.row.Dxcode8 !== null ? params.row.Dxcode8 : ''} ${params.row.Dx8Description}`}
									{params?.row?.Dx8Description && <br />}
									{` ${params.row.Dxcode9 !== null ? params.row.Dxcode9 : ''} ${params.row.Dx9Description}`}
									{params?.row?.Dx9Description && <br />}
									{`${params.row.Dxcode10 !== null ? params.row.Dxcode10 : ''} ${params.row.Dx10Description}`}
									{params?.row?.Dx10Description && <br />}
									{`${params.row.Dxcode11 !== null ? params.row.Dxcode11 : ''} ${params.row.Dx11Description}`}
									{params?.row?.Dx11Description && <br />}
									{`${params.row.Dxcode12 !== null ? params.row.Dxcode12 : ''} ${params.row.Dx12Description}`}
									{params?.row?.Dx12Description && <br />}
									{/* `} */}
								</>
							}
						>
							<span
								style={{
									fontStyle: 'italic',
									fontSize: '12px',
									color: '#60739d',
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'nowrap',
									display: 'block',
								}}
							>
								{`${params.row.Dxcode1 !== null ? params.row.Dxcode1 : ''} ${params.row.Dx1Description}`}{' '}
								<br />
								{` ${params.row.Dxcode2 !== null ? params.row.Dxcode2 : ''} ${params.row.Dx2Description}`}
								<br />
							</span>
						</Tooltip>

						<span
							style={{
								fontWeight: '300',
								fontStyle: 'italic',
								// textDecoration: 'underline',
								textAlign: 'center',
								textWrap: 'wrap',
							}}
						></span>
					</Typography>
				</Box>
			),
		},
		{
			field: 'visitStatus',
			headerName: 'V-Status',
			minWidth: 120,
			flex: 0.7,
			renderCell: (params) => {
				return (
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							width: '100%',
						}}
					>
						{statusPill(params.value)}
					</Box>
				);
			},
		},
		// {
		// 	field: 'Action',
		// 	headerName: 'Action',
		// 	width: 100,
		// 	renderCell: (cellValues) => {
		// 		return (
		// 			<Box>
		// 				<img src={eye} width="13.74px" style={{ cursor: 'pointer' }} />
		// 				<PopupState variant="popover" popupId="demo-popup-menu">
		// 					{(popupState) => (
		// 						<React.Fragment>
		// 							<Button {...bindTrigger(popupState)}>
		// 								<img
		// 									src={icon5}
		// 									width="9px"
		// 									style={{ cursor: 'pointer' }}
		// 								/>
		// 							</Button>
		// 							<Menu
		// 								{...bindMenu(popupState)}
		// 								sx={{
		// 									'& .MuiMenu-paper': {
		// 										marginLeft: '-2rem',
		// 									},
		// 								}}
		// 							>
		// 								<MenuItem
		// 									onClick={popupState.close}
		// 									sx={{
		// 										fontFamily: 'Poppins',
		// 										fontWeight: '500',
		// 										fontSize: '14px',
		// 										color: '#4D4F51',
		// 									}}
		// 								>
		// 									Archived Batch
		// 								</MenuItem>
		// 								<MenuItem
		// 									onClick={popupState.close}
		// 									sx={{
		// 										fontFamily: 'Poppins',
		// 										fontWeight: '500',
		// 										fontSize: '14px',
		// 										color: '#4D4F51',
		// 									}}
		// 								>
		// 									Report Batch
		// 								</MenuItem>
		// 								<MenuItem
		// 									onClick={popupState.close}
		// 									sx={{
		// 										fontFamily: 'Poppins',
		// 										fontWeight: '500',
		// 										fontSize: '14px',
		// 										color: '#4D4F51',
		// 									}}
		// 								>
		// 									Delete Batch
		// 								</MenuItem>
		// 							</Menu>
		// 						</React.Fragment>
		// 					)}
		// 				</PopupState>
		// 			</Box>
		// 		);
		// 	},
		// },
	];

	const rows =
		// searchBy !== '' && filterData.length > 0
		// 	? filterData
		// 	:
		filterData?.map((items, i) => {
			return {
				uniqueID: i,

				patientName:
					items?.patient === null
						? ''
						: items?.patient?.Lname + ', ' + items?.patient?.Fname,

				ProviderName:
					// items?.practicestaff?.Lname + ', ' + items?.practicestaff?.Fname : "",
					items?.practicestaff?.Lname || items?.practicestaff?.Fname
						? `${items?.practicestaff?.Lname || ''}${items?.practicestaff?.Fname ? ', ' + items?.practicestaff?.Fname : ''}`
						: '',

				// DateOFBirth: dayjs(
				// 	items.patient === null ? 'NULL' : items.patient.DOB
				// ).format('DD/MM/YYYY'),
				visitDate: dayjs(
					items?.VisitDate === null ? '' : items?.VisitDate
				).format('MM-DD-YYYY'),

				visitStatus: items?.VisitStatus === null ? '' : items?.VisitStatus,

				// charges: items?.visit_cpts
				// 	?.map((data) => (data?.CPTCode === null ? '' : data?.CPTCode))
				// 	.toString(),
				charges: items?.visit_cpts,
				Dxcode1: items?.Dxcode1 === null ? '' : items?.Dxcode1,
				Dxcode2: items?.Dxcode2 === null ? '' : items?.Dxcode2,
				Dxcode3: items?.Dxcode3 === null ? '' : items?.Dxcode3,
				Dxcode4: items?.Dxcode4 === null ? '' : items?.Dxcode4,
				Dxcode5: items?.Dxcode5 === null ? '' : items?.Dxcode5,
				Dxcode6: items?.Dxcode6 === null ? '' : items?.Dxcode6,
				Dxcode7: items?.Dxcode7 === null ? '' : items?.Dxcode7,
				Dxcode8: items?.Dxcode8 === null ? '' : items?.Dxcode8,
				Dxcode9: items?.Dxcode9 === null ? '' : items?.Dxcode9,
				Dxcode10: items?.Dxcode10 === null ? '' : items?.Dxcode10,
				Dxcode11: items?.Dxcode11 === null ? '' : items?.Dxcode11,
				Dxcode12: items?.Dxcode12 === null ? '' : items?.Dxcode12,
				Dx1Description:
					items?.Dx1Description === null ? '' : items?.Dx1Description,
				Dx2Description:
					items?.Dx2Description === null ? '' : items?.Dx2Description,
				Dx3Description:
					items?.Dx3Description === null ? '' : items?.Dx3Description,
				Dx4Description:
					items?.Dx4Description === null ? '' : items?.Dx4Description,
				Dx5Description:
					items?.Dx5Description === null ? '' : items?.Dx5Description,
				Dx6Description:
					items?.Dx6Description === null ? '' : items?.Dx6Description,
				Dx7Description:
					items?.Dx7Description === null ? '' : items?.Dx7Description,
				Dx8Description:
					items?.Dx8Description === null ? '' : items?.Dx8Description,
				Dx9Description:
					items?.Dx9Description === null ? '' : items?.Dx9Description,
				Dx10Description:
					items?.Dx10Description === null ? '' : items?.Dx10Description,
				Dx11Description:
					items?.Dx11Description === null ? '' : items?.Dx11Description,
				Dx12Description:
					items?.Dx12Description === null ? '' : items?.Dx12Description,
			};
		});

	const CustomToolbar = () => {
		const customStyles = `
      .MuiTablePagination-actions,
      .MuiTablePagination-displayedRows {
        display: none !important;
      },
    `;
		const styleElement = document.createElement('style');
		styleElement.innerHTML = customStyles;
		document.head.appendChild(styleElement);
	};

	const paginationMenuOpen = (event) => {
		setPagination(event.currentTarget);
	};

	const paginationMenuClose = () => {
		setPagination(null);
	};
	// pagination logic function is here
	const getItemsForPage = (pageNumber, pageSize) => {
		const startIndex = (pageNumber - 1) * pageSize;
		const endIndex = startIndex + pageSize;
		return allBatchData.slice(startIndex, endIndex);
	};

	const batchDetailsDataFunc = async () => {
		setBatchesLoader(true);
		const resp = await getBatches();
		if (resp?.status == 200) {
			setBatchesDetailsData(resp?.data?.reverse());
			setAllBatchData(resp?.data?.reverse());
			setBatchesLoader(false);
			setfirstBatch(resp?.data?.length > 0 && resp?.data?.reverse()[0]);
			if (resp?.data?.length < 5) {
				setPageSize(resp?.data?.length);
			} else {
				setPageSize(5);
			}
		} else {
			setBatchesDetailsData([]);
			setAllBatchData([]);
		}
	};

	// const getBatchDetailWith_BatchID = async (batch_id) => {
	//
	// 	const resp = await getBatchesWithbatch_id(batch_id);
	// 	setSelectedBatchGrid(resp.data);
	// };

	// function for geting practice Staff data on this screen move to batch textfields
	const getPracticeStaffAllData = async () => {
		const resp = await getPracticeStaff();
		setPracticeStaff(resp.data);
	};

	const handleUpdateBatchFields = (event) => {
		setUpdateBatchName(event.target.value);
	};

	//  body-json for updateBatches
	const updateBatchData = {
		BatchName: updateBatchName,
		practice_id: practiceId_fromLocal,
		// AssignedTo_id: updateAssignTo,
		// AssignedTo_id: 1,
	};
	const updateBatchFunc = async (id, data) => {
		const resps = await updateBatch(id, data);
		if (resps.status == 200) {
			setBatchDeleted(false);
			setPostSucessfully(true);
			setOpenSnackbar(true);
			batchDetailsDataFunc();
		} else {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};

	const unBatchFunc = async (id, data) => {
		const resps = await updateBatch(id, data);
		if (resps.status == 200) {
			setBatchDeleted(true);
			setOpenSnackbar(true);
			batchDetailsDataFunc();
		}
	};
	// making this function just to avoid snackbar while exporting excel
	const exportBatch = async (id, data) => {
		const resps = await updateBatch(id, data);
		if (resps.status == 200) {
			setBatchDeleted(false);
			batchDetailsDataFunc();
		} else {
			setPostSucessfully(false);
			setOpenSnackbar(true);
		}
	};
	//   Download csv file
	const downloadCSV = (batchID, batchName) => {
		const columns = [
			// Column Fields Name here
			[
				'Patient Name',
				'DOB',
				'Primary Payer',
				'Policy Number',
				'Gender',
				'Provider Name',
				'CPT Codes',
				'Dx Codes ',
				'Location',
				'V-Status',
				'Visit Date',
				'Admission Date',
				'Referring Physician',
				'Discharge date',
			],
		];
		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);
		const exportThisBatchVisitsData = visitData.filter(
			(data) => data.batch_id == batchID
		);
		// Assuming apiData is an array of objects
		exportThisBatchVisitsData?.forEach((item, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						// item?.id,
						`${item?.patient?.Lname + ', ' + item?.patient?.Fname}`,
						`${dayjs(item?.patient?.DOB).format('MM/DD/YYYY')}`,
						`${item?.patient?.patient_insurances[0]?.payer?.Name !== undefined ? item?.patient?.patient_insurances[0]?.payer?.Name : ''}`,
						`${item?.patient?.patient_insurances[0]?.PolicyNumber !== undefined ? item?.patient?.patient_insurances[0]?.PolicyNumber : ''}`,
						`${item?.patient?.Gender === 'F' ? 'Female' : item?.patient?.Gender === 'M' ? 'Male' : item?.patient?.Gender}`,
						`${item?.practicestaff?.Lname + ', ' + item?.practicestaff?.Fname}`,
						item?.visit_cpts
							.map((data) => (data?.CPTCode === null ? '' : data?.CPTCode))
							.toString(),

						`${item?.Dxcode1 === null ? '' : item?.Dxcode1 + ','}${item?.Dxcode2 === null ? '' : item?.Dxcode2 + ','} ${item?.Dxcode3 === null ? '' : item?.Dxcode3 + ','} ${item?.Dxcode4 === null ? '' : item?.Dxcode4 + ','} ${item?.Dxcode5 === null ? '' : item?.Dxcode5 + ','} ${item?.Dxcode6 === null ? '' : item?.Dxcode6 + ','} ${item?.Dxcode7 === null ? '' : item?.Dxcode7 + ','} ${item?.Dxcode8 === null ? '' : item?.Dxcode8 + ','} ${item?.Dxcode9 === null ? '' : item?.Dxcode9 + ','} ${item?.Dxcode10 === null ? '' : item?.Dxcode10 + ','} ${item?.Dxcode11 === null ? '' : item?.Dxcode11 + ','} ${item?.Dxcode12 === null ? '' : item?.Dxcode12 + ','} `,

						`${item?.location !== undefined ? item?.location?.Name : ''}`,
						`${item?.VisitStatus == 'A' ? 'APPROVED' : item?.VisitStatus === null ? 'OTHERS' : item?.VisitStatus == 'B' ? 'BILLED' : item?.VisitStatus == 'D' ? 'DRAFT' : ''}`,

						`${dayjs(item?.VisitDate).format('MM/DD/YYYY')}`,

						dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY'),
						`${item?.referringPhysician?.Fname + ', ' + item?.referringPhysician?.Lname}`,
						item?.admission?.discharge_date
							? dayjs(item?.admission?.discharge_date).format('MM/DD/YYYY')
							: null,
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(
			workbook,
			`${batchName}_${dayjs(new Date()).format('MM-DD-YYYY')}.xlsx`
		);
	};
	// Visit Data
	const getVisitData = async () => {
		try {
			setLoader(true);
			const response = await getVisit();
			if (response?.status === 200) setVisitData(response?.data);
			else setVisitData([]);
			setLoader(false);
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoader(false);
		}
	};

	useEffect(() => {
		batchDetailsDataFunc();
		getPracticeStaffAllData();
		getVisitData();
	}, [reRenderAgain]);
	useEffect(() => {
		if (firstBatch) {
			setClicked(firstBatch?.id);
			setCurrentlySelecteBatch({
				id: firstBatch?.id,
				BatchName: firstBatch?.BatchName,
				charges: firstBatch?.num_visits,
				CreatedDate:
					firstBatch?.AssignedTo === null
						? ''
						: dayjs(firstBatch?.CreatedDate).format('MM/DD/YYYY'),
			});
			setSelectedBatchGrid(
				visitData?.filter((i) => i.batch_id == firstBatch?.id)
			);
			setFilterData(visitData?.filter((i) => i.batch_id == firstBatch?.id));
		}
	}, [firstBatch, batchesStatus, visitData]);
	// this useEffect for setting batches according to pagination when it firs time loaded
	useEffect(() => {
		const currentShowingBatches = getItemsForPage(1, pageSize);
		setBatchesDetailsData(currentShowingBatches);
	}, [batchesLoader]);
	return (
		<>
			<Dialog
				open={open}
				// minWidth
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				PaperProps={{
					sx: {
						...batchModalPaperSx,
						width: 'min(480px, calc(100vw - 32px))',
						m: 0,
					},
				}}
			>
				<Box
					sx={{
						height: 58,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						borderBottom: '1px solid #edf2f8',
						px: 2.2,
					}}
				>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontSize: '18px',
							fontWeight: 700,
							color: '#0b2450',
						}}
					>
						Update Batch
					</Typography>
					<IconButton size="small" onClick={handleClose} sx={{ color: '#0b2450' }}>
						<Cancel sx={{ fontSize: '22px' }} />
					</IconButton>
				</Box>
				<DialogContent sx={{ p: 2.4 }}>
					<Box
						sx={{
							width: 62,
							height: 62,
							borderRadius: '50%',
							backgroundColor: '#edf4ff',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							mx: 'auto',
							mb: 2,
						}}
					>
						<FactCheckOutlinedIcon sx={{ color: '#2f6edb', fontSize: '30px' }} />
					</Box>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontWeight: 500,
							fontSize: '13px',
							color: '#64748b',
							textAlign: 'center',
							mb: 2,
						}}
					>
						Review the batch name before updating this batch.
					</Typography>
					<Grid container>
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Typography sx={batchModalLabelSx}>Batch Name</Typography>
							<TextField
								helperText={
									updateBatchName === ''
										? 'Batch Name Should not be Empty!'
										: ''
								}
								id="outlined-required"
								error={updateBatchName === '' ? true : false}
								fullWidth
								size="medium"
								name="updateBatchNameField"
								value={updateBatchName}
								onChange={handleUpdateBatchFields}
								placeholder="Enter batch name"
								sx={batchModalFieldSx}
							/>
						</Grid>
						{/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<FormControl fullWidth>
								<Typography fontWeight={'bold'}>Assign To</Typography>

								<Select
									sx={{ boxShadow: '1px 1px 10px #79ACF178 inset' }}
									name="assignedTo"
									id="demo-simple-select"
									value={updateAssignTo}
									onChange={(e) => {
										setUpdateAssignTo(e.target.value);
									}}
								>
									{practiceStaff.map((items, i) => {
										return (
											<MenuItem value={items.id} key={i}>
												{items.Fname + ' ' + items.Lname}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</Grid> */}
						{/* <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
							<Typography
								sx={{
									fontFamily: 'Poppins',
									fontWeight: '500',
									fontSize: '14px',
									color: '#000000',
								}}
							>
								Description
							</Typography>
							<TextField
								id="outlined-multiline-static"
								multiline
								rows={4}
								fullWidth
								size="medium"
								name="update_BatchDescriptionField"
							/>
						</Grid> */}
					</Grid>
				</DialogContent>
				<DialogActions sx={{ gap: 1.5, borderTop: '1px solid #edf2f8', px: 2.4, py: 1.5 }}>
					<Button
						startIcon={<Cancel sx={{ fontSize: '18px' }} />}
						sx={batchModalOutlineButtonSx}
						variant="contained"
						size="large"
						autoFocus
						onClick={handleClose}
					>
						Cancel
					</Button>
					<Button
						disabled={updateBatchName === '' ? true : false}
						startIcon={<FactCheckOutlinedIcon sx={{ fontSize: '18px' }} />}
						sx={batchModalPrimaryButtonSx}
						variant="contained"
						size="large"
						onClick={() => {
							updateBatchFunc(currentlySelecteBatch.id, updateBatchData);
							setRerenderAgain((prev) => prev + 1);
							handleClose();
						}}
						autoFocus
					>
						Update
					</Button>
				</DialogActions>
			</Dialog>
			<Grid
				container
				spacing={1.5}
				sx={{
					px: 2,
					pt: 2,
					pb: 1.5,
					bgcolor: '#f6f8fb',
					minHeight: 'calc(100vh - 46px)',
					fontFamily: 'Poppins',
				}}
			>
				<Grid
					item
					xl={3.8}
					lg={3.8}
					md={4.5}
					sm={12}
					xs={12}
					sx={{
						display: 'flex',
						flexDirection: 'column',
						bgcolor: '#fff',
						border: '1px solid #dce6f3',
						borderRadius: '8px',
						p: 1.5,
						minHeight: 0,
						maxHeight: { xl: 600, lg: 560, md: 560, sm: 'none', xs: 'none' },
					}}
				>
					{/* <Grid container spacing={2}>
							<Grid item xl={5.5} lg={5.5} md={5.5} sm={5.5} xs={5.5}>
								<Grid container>
									<Grid item xl={1} lg={1} md={1} sm={1} xs={1}></Grid>
									<Grid item xl={11} lg={11} md={11} sm={11} xs={11}>
										<FormControl fullWidth size="small">
											<Select
												value={provider}
												onChange={providerHandler}
												displayEmpty
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													fontSize: '14',
													fontFamily: 'Poppins',
													fontWeight: '400',
													color: '#4D4F51',
													marginTop: '1rem',
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">Provider</MenuItem>
												
											</Select>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xl={6.5} lg={6.5} md={6.5} sm={6.5} xs={6.5}>
								<Grid container>
									<Grid item xl={11} lg={11} md={11} sm={11} xs={11}>
										<FormControl fullWidth size="small">
											<Select
												value={"viewAllBacthes"}
												displayEmpty
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													fontSize: '14',
													fontFamily: 'Poppins',
													fontWeight: '400',
													color: '#4D4F51',
													marginTop: '1rem',
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">View All Batches</MenuItem>
												
											</Select>
										</FormControl>
									</Grid>
									<Grid item xl={1} lg={1} md={1} sm={1} xs={1}></Grid>
								</Grid>
							</Grid>
						</Grid> */}

					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							width: '100%',
						}}
					>
						<Typography
							sx={{
								width: '100%',
								fontFamily: 'Poppins',
								fontWeight: 700,
								fontSize: '18px',
								color: '#172d58',
								mb: 1.5,
							}}
						>
							Batches Detail
						</Typography>
						<Box width={'100%'}>
							<Box
								sx={{
									width: '100%',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<TextField
									onChange={(e) => {
										const searchBatchesByName = allBatchData?.filter(
											(items) => {
												return items?.BatchName.toLowerCase().includes(
													e.target.value.toLowerCase().trim()
												);
											}
										);
										if (e.target.value === '') {
											// setBatchesDetailsData(allBatchData);
											const currentShowingBatches = getItemsForPage(
												1,
												pageSize
											);
											setBatchesDetailsData(currentShowingBatches);
										} else {
											setBatchesDetailsData(searchBatchesByName);
										}
									}}
									id="searchBatchesByName"
									variant="outlined"
									placeholder="Search Batch by Name"
									fullWidth
									size="small"
									InputProps={{
										endAdornment: (
											<InputAdornment position="end">
												<SearchIcon sx={{ color: '#60739d', fontSize: 22 }} />
											</InputAdornment>
										),
									}}
									sx={{
										'& .MuiInputBase-root': {
											height: 40,
											borderRadius: '6px',
											fontFamily: 'Poppins',
											fontSize: '13px',
										},
										'& .MuiOutlinedInput-notchedOutline': {
											borderColor: '#d6e2f2',
										},
										'& input': { color: '#172d58' },
									}}
								/>
							</Box>
						</Box>
					</Box>
					{/* <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
							<FormControl fullWidth size="small">
											<InputLabel id="demo-simple-select-label">
												Status
											</InputLabel>

											<Select
												label="Status"
												name="statusSelect"
												value={batchesStatus}
												onChange={batchesStatusHandler}
												inputProps={{ 'aria-label': 'Without label' }}
												sx={{
													fontSize: '14',
													fontFamily: 'Poppins',
													fontWeight: '400',
													color: '#4D4F51',
													'& .MuiOutlinedInput-notchedOutline': {
														boxShadow: '-5px 0px #FD7702',
													},
												}}
											>
												<MenuItem value="">Clear Filter</MenuItem>
												<MenuItem value="E" >Exported</MenuItem>
												<MenuItem value="P">Pending</MenuItem>
											</Select>
										</FormControl>
						</Grid> */}

					{!batchesLoader && batchesDetailsData?.length === 0 && (
						<Box
							width={'100%'}
							// height={'50vh'}
							display={'flex'}
							justifyContent={'center'}
							alignItems={'center'}
						>
							<span
								style={{
									color: '#2081B8',
									marginRight: '5px',
									fontWeight: 'bold',
									// height: '100%',
									// width: '100%',
								}}
							>
								{batchesDetailsData?.length}{' '}
							</span>
							Batches in Record
						</Box>
					)}
					{batchesLoader ? (
						<BrandedLoader
							title="Loading batches"
							text="Preparing batch records"
							minHeight="360px"
						/>
					) : (
						<Box
							sx={{
								overflow: 'auto',
								flex: 1,
								width: '100%',
								maxHeight: { xl: 465, lg: 425, md: 425, sm: 360, xs: 360 },
								border: 0,
								padding: '6px 0',
								scrollbarWidth: 'thin',
								'&::-webkit-scrollbar': { width: '6px' },
								'&::-webkit-scrollbar-thumb': {
									backgroundColor: '#c7d4e8',
									borderRadius: '999px',
								},
							}}
						>
							{batchesDetailsData
								// filterBatchWithStatus.length > 0
								// ? filterBatchWithStatus
								// :
								.map((items, i) => {
									return (
										<Box
											key={i}
											onClick={() => {
												handleClick(items);
											}}
											sx={batchCardSx(items.id)}
											// sx={{ margin: '5px 8px' }}
											// sx={{
											// 	height: {
											// 		xl: '78px',
											// 		lg: '88px',
											// 		md: '120px',
											// 		sm: '78px',
											// 		xs: '120px',
											// 	},
											// 	// marginTop: '-0.5rem'
											// }}
											// my={1}
										>
											<Box
												sx={{
													position: 'absolute',
													left: 16,
													top: '50%',
													transform: 'translateY(-50%)',
													width: 42,
													height: 42,
													borderRadius: '50%',
													bgcolor: '#f4f8ff',
													border: '1px solid #e4ebf6',
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													color: '#1f66ff',
												}}
											>
												<FolderOutlinedIcon fontSize="small" />
											</Box>
											<Grid container>
												<Grid item xl={6.5} lg={6.5} md={6.5} sm={6.5} xs={6.5}>
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
																whiteSpace: 'nowrap',
															}}
														>
															Batch Name:
															<span
																style={{
																	fontFamily: 'Poppins',
																	fontWeight: '600',
																	fontSize: '13px',
																	color: '#407BFF',
																	paddingLeft: '6px',
																}}
															>
																{items?.BatchName?.length > 10
																	? items?.BatchName?.slice(0, 10) + '...'
																	: items?.BatchName}
															</span>
														</Typography>
													</Grid>

													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
															}}
														>
															Created Date:{' '}
															<span>
																{/* {items?.AssignedTo?.first_name +
																	' ' +
																	items?.AssignedTo?.last_name} */}
																{dayjs(items?.CreatedDate).format('MM-DD-YYYY')}
															</span>
														</Typography>
													</Grid>
												</Grid>

												<Grid
													item
													xl={4.5}
													lg={4.5}
													md={4.5}
													sm={4.5}
													xs={4.5}
													sx={{ paddingLeft: '15px' }}
												>
													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
																whiteSpace: 'nowrap',
																textOverflow: 'ellipsis',
																overflow: 'hidden',
															}}
														>
															Charges:{' '}
															<span style={{ color: '#407BFF' }}>
																{items?.num_visits}
															</span>
														</Typography>
													</Grid>

													<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
														<Typography
															sx={{
																fontFamily: 'Poppins',
																fontWeight: '500',
																fontSize: '13px',
																color: '#000000',
															}}
														>
															{/* Date: */}
															Status:{' '}
															<span
																style={
																	items?.BatchStatus === 'E'
																		? { color: 'green' }
																		: { color: '#CBC311' }
																}
															>
																{' '}
																{items?.BatchStatus === 'E'
																	? 'Exported'
																	: items?.BatchStatus === 'P'
																		? 'Pending'
																		: ''}
															</span>
														</Typography>
													</Grid>
												</Grid>
												<Grid
													item
													xl={1}
													lg={1}
													md={1}
													sm={1}
													xs={1}
													// align="right"
												>
													<PopupState
														variant="popover"
														popupId="demo-popup-menu"
													>
														{(popupState) => (
															<React.Fragment>
																{/* <img
																	src={icon3}
																	width="3.23px"
																	height="14px"
																	// style={{ marginTop: '0.5rem' }}
																/>{' '} */}
																<IconButton>
																	<MoreVertIcon {...bindTrigger(popupState)} />
																</IconButton>
																<Menu
																	{...bindMenu(popupState)}
																	sx={{
																		'& .MuiMenu-paper': {
																			marginLeft: '-2.5rem',
																			marginTop: '-2rem',
																		},
																		'& .MuiPaper-root': {
																			width: '80px',
																			// height: '27%',
																		},
																	}}
																>
																	<MenuItem
																		onClick={() => {
																			unBatchFunc(items.id, {
																				BatchName: items.BatchName,
																				practice_id: practiceId_fromLocal,
																				// AssignedTo_id:
																				// 	items.AssignedTo_id,
																				// AssignedTo_id: 2,
																				Deleted: true,
																			});

																			popupState.close();
																		}}
																		sx={{
																			fontFamily: 'Poppins',
																			fontWeight: '500',
																			fontSize: '11.5px',
																			color: '#000000',
																		}}
																	>
																		Unbatch
																	</MenuItem>

																	<MenuItem
																		onClick={() => {
																			setUpdateBatchName(items.BatchName);
																			setUpdateAssignTo(items.AssignedTo_id);
																			setCurrentlySelecteBatch({
																				id: items?.id,
																				BatchName: items?.BatchName,
																				charges: items?.num_visits,
																				CreatedDate: items?.CreatedDate,
																				AssignedTo_id: items?.AssignedTo_id,
																			});
																			handleClickOpen();
																			popupState.close();
																		}}
																		sx={{
																			fontFamily: 'Poppins',
																			fontWeight: '500',
																			fontSize: '11.5px',
																			color: '#000000',
																		}}
																	>
																		Update
																	</MenuItem>
																	<MenuItem
																		onClick={() => {
																			downloadCSV(items.id, items.BatchName);
																			exportBatch(items.id, {
																				BatchName: items?.BatchName,
																				practice_id: practiceId_fromLocal,
																				// AssignedTo_id: items.AssignedTo,
																				// AssignedTo_id: 1,
																				BatchStatus: 'E',
																			});

																			popupState.close();
																		}}
																		sx={{
																			fontFamily: 'Poppins',
																			fontWeight: '500',
																			fontSize: '11.5px',
																			color: '#000000',
																		}}
																	>
																		Export
																	</MenuItem>
																	{/* <MenuItem
																						onClick={() => {
																							popupState.close();
																						}}
																						sx={{
																							fontFamily: 'Poppins',
																							fontWeight: '500',
																							fontSize: '11.5px',
																							color: '#000000',
																						}}
																					>
																						Create Visit
																					</MenuItem>
																					<MenuItem
																						onClick={popupState.close}
																						sx={{
																							fontFamily: 'Poppins',
																							fontWeight: '500',
																							fontSize: '11.5px',
																							color: '#000000',
																						}}
																					>
																						Archive
																					</MenuItem>
																					<MenuItem
																						onClick={popupState.close}
																						sx={{
																							fontFamily: 'Poppins',
																							fontWeight: '500',
																							fontSize: '11.5px',
																							color: '#ED2828',
																						}}
																					>
																						Delete
																					</MenuItem> */}
																</Menu>
															</React.Fragment>
														)}
													</PopupState>
												</Grid>
											</Grid>
										</Box>
									);
								})}
						</Box>
					)}
					{/* pagination here */}
					{!batchesLoader &&
							(filterBatchWithStatus?.length > 0 ||
								batchesDetailsData?.length > 0) && (
							<Box
								display={'flex'}
								justifyContent={'flex-end'}
								alignItems={'center'}
								gap={1}
								sx={{
									borderTop: '1px solid #e6edf7',
									pt: 1,
									mt: 'auto',
									px: 0.5,
								}}
							>
								<Typography
									sx={{
										alignSelf: 'center',
										mr: 1.5,
										fontSize: '12px',
										fontWeight: 600,
										color: '#172d58',
										fontFamily: 'Poppins',
									}}
								>
									{`${batchesDetailsData?.length || 0} / ${allBatchData?.length || 0}`}
								</Typography>
								<Box
									// elevation={5}
									sx={{
										border: '1px solid #dfe7f3',
										borderRadius: '6px',
										height: 34,
										minWidth: 58,
										px: 1,
										bgcolor: '#fff',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										textAlign: 'center',
										fontSize: '12px',
										fontFamily: 'Poppins',
										fontWeight: 600,
										color: '#172d58',
										cursor: 'pointer',
									}}
									onClick={paginationMenuOpen}
								>
									{`${pageSize}`}
									<ArrowDropDown fontSize="13px" />
								</Box>
								<Menu
									sx={{
										marginLeft: '13px',
										// width: '81px',
										// margin: '20px',
										// backgroundColor: 'red',
									}}
									anchorEl={pagination}
									open={Boolean(pagination)}
									onClose={paginationMenuClose}
								>
									{[
										allBatchData?.length > 5 && 5,
										allBatchData?.length > 10 && 10,
										allBatchData?.length > 25 && 25,
										allBatchData?.length > 50 && 50,
										allBatchData?.length,
									].map((size, indexNumber) => {
										if (size != false) {
											return (
												<MenuItem
													key={indexNumber}
													onClick={() => {
														setPageSize(size);
														const currentShowingBatches = getItemsForPage(
															1,
															size
														);
														setBatchesDetailsData(currentShowingBatches);
														paginationMenuClose();
													}}
												>
													{size}
												</MenuItem>
											);
										}
									})}
								</Menu>
							</Box>
						)}
				</Grid>
				<Grid
					item
					xl={8.2}
					lg={8.2}
					md={7.5}
					sm={12}
					xs={12}
					sx={{
						bgcolor: '#fff',
						border: '1px solid #dce6f3',
						borderRadius: '8px',
						overflow: 'hidden',
						minHeight: 0,
						maxHeight: { xl: 600, lg: 560, md: 560, sm: 'none', xs: 'none' },
					}}
				>
					{allBatchData?.length > 0 && (
						<Box
							sx={{
								borderBottom: '1px solid #e6edf7',
								p: '16px 18px',
								display: 'grid',
								gridTemplateColumns: {
									xl: '1fr 1fr 1fr 320px',
									lg: '1fr 1fr 1fr 300px',
									md: '1fr 1fr',
									xs: '1fr',
								},
								alignItems: 'center',
								gap: 2,
							}}
						>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
								<Box
									sx={{
										width: 38,
										height: 38,
										borderRadius: '8px',
										bgcolor: '#f0f5ff',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										color: '#5272a8',
									}}
								>
									<FactCheckOutlinedIcon fontSize="small" />
								</Box>
								<Box>
									<Typography sx={{ fontSize: 12, color: '#60739d' }}>
										Batch Name
									</Typography>
									<Typography
										noWrap
										sx={{ fontSize: 14, fontWeight: 700, color: '#172d58' }}
									>
										{currentlySelecteBatch?.BatchName || '-'}
									</Typography>
								</Box>
							</Box>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
								<Box
									sx={{
										width: 38,
										height: 38,
										borderRadius: '8px',
										bgcolor: '#f0f5ff',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										color: '#5272a8',
									}}
								>
									<ManageAccountsOutlinedIcon fontSize="small" />
								</Box>
								<Box>
									<Typography sx={{ fontSize: 12, color: '#60739d' }}>
										Charges
									</Typography>
									<Typography sx={{ fontSize: 14, fontWeight: 700, color: '#172d58' }}>
										{currentlySelecteBatch?.charges || 0}
									</Typography>
								</Box>
							</Box>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
								<Box
									sx={{
										width: 38,
										height: 38,
										borderRadius: '8px',
										bgcolor: '#f0f5ff',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										color: '#5272a8',
									}}
								>
									<CalendarMonthOutlinedIcon fontSize="small" />
								</Box>
								<Box>
									<Typography sx={{ fontSize: 12, color: '#60739d' }}>
										Date
									</Typography>
									<Typography sx={{ fontSize: 14, fontWeight: 700, color: '#172d58' }}>
										{currentlySelecteBatch?.CreatedDate || '-'}
									</Typography>
								</Box>
							</Box>
							<TextField
								variant="outlined"
								placeholder="Search By Patient Name"
								value={searchBy}
								onChange={handleSearchByFilter}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<SearchIcon sx={{ color: '#60739d', fontSize: 22 }} />
										</InputAdornment>
									),
								}}
								fullWidth
								size="small"
								sx={{
									'& .MuiInputBase-root': {
										height: 40,
										borderRadius: '6px',
										fontFamily: 'Poppins',
										fontSize: '13px',
									},
									'& .MuiOutlinedInput-notchedOutline': {
										borderColor: '#d6e2f2',
									},
								}}
							/>
						</Box>
					)}
					<Box
						sx={{
							height: 'auto',
							maxHeight: { xl: 525, lg: 485, md: 485, sm: 520, xs: 520 },
						}}
					>
						{loader ? (
							<BrandedLoader
								title="Loading batches"
								text="Preparing batch records"
								minHeight="360px"
							/>
						) : allBatchData?.length > 0 ? (
							<DataGrid
								// rows={selectedBatchGrid}
								rows={rows}
								columns={columns}
								columnHeaderHeight={40}
								initialState={{
									pagination: { paginationModel: { pageSize: 5 } },
								}}
								pageSizeOptions={[5, 10, 25]}
								rowHeight={72}
								autoHeight
								// checkboxSelection
								disableRowSelectionOnClick
								sx={gridSx}
								slotProps={{
									pagination: { labelRowsPerPage: 'Rows per page:' },
								}}
								getRowId={(row) => row.uniqueID}
							/>
						) : (
							<Box
								width={'100%'}
								height={'50vh'}
								display={'flex'}
								justifyContent={'center'}
								alignItems={'center'}
							>
								<span
									style={{
										color: '#2081B8',
										marginRight: '5px',
										fontWeight: 'bold',
										// height: '100%',
										// width: '100%',
									}}
								>
									{allBatchData?.length}{' '}
								</span>
								Batches in Record
							</Box>
						)}
					</Box>

					{/* SnackBar */}
					<Snackbar
						open={openSnackbar}
						autoHideDuration={3000}
						onClose={handleCloseSnackbar}
						anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
					>
						<Alert
							onClose={handleCloseSnackbar}
							severity={
								!postSucessfully ? 'error' : batchDeleted ? 'error' : 'success'
							}
							variant="filled"
							sx={{
								width: '100%',
								height: '3.5rem',
								textAlign: 'center',
								fontSize: '1.1rem',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							action={
								<React.Fragment>
									<span
										onClick={handleCloseSnackbar}
										style={{
											cursor: 'pointer',
											m: 'auto 0',
											fontSize: '13px',
											color: 'rgb(231, 231, 231)',
										}}
									>
										Close
									</span>
								</React.Fragment>
							}
						>
							{!postSucessfully
								? 'Error!'
								: batchDeleted
									? 'Batch is Unbtached'
									: 'Batch Update Successfully!'}
						</Alert>
					</Snackbar>
				</Grid>
			</Grid>
		</>
	);
}

export default Batches;
